import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import SalesFeePage from "./SalesFeePage";
import { Footer } from "../../../components/Footer";

const SalesSourcePage = () =>{
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const [salesSource, setSalesSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const columns = [
        {
            Header: "Distributor Branch ID Type",
            accessor: "DistributorBranchIDType",
            filter: "DistributorBranchIDType",
            sortType: "basic",
        },
        {
            Header: "Distributor Branch ID",
            accessor: "DistributorBranchID",
            filter: "DistributorBranchID",
            sortType: "basic",
        },
        {
            Header: "Distributor Branch City",
            accessor: "DistributorBranchCity",
            filter: "DistributorBranchCity",
            sortType: "basic",
        },
        {
            Header: "Account ID Type",
            accessor: "AccountIDType",
            filter: "AccountIDType",
            sortType: "basic",
        },
        {
            Header: "Account ID",
            accessor: "AccountID",
            filter: "AccountID",
            sortType: "basic",
            // filterMethod: (filter, row) => {
            //     const rowValue = row.original
            //     return rowValue.datefiled.includes(filter.value)
            // }
        },
        {
            Header: "Org Name",
            accessor: "OrgName",
            filter: "OrgName",
            sortType: "basic",
        },
        {
            Header: "Physician Last Name",
            accessor: "PhysicianLastName",
            filter: "PhysicianLastName",
            sortType: "basic",
        },
        {
            Header: "Physician First Name",
            accessor: "PhysicianFirstName",
            filter: "PhysicianFirstName",
            sortType: "basic",
        },
        {
            Header: "Account Address 1",
            accessor: "AccountAddress1",
            filter: "AccountAddress1",
            sortType: "basic",
        },
        {
            Header: "Account Address 2",
            accessor: "AccountAddress2",
            filter: "AccountAddress2",
            sortType: "basic",
        },
        {
            Header: "Account City",
            accessor: "AccountCity",
            filter: "AccountCity",
            sortType: "basic",
        },
        {
            Header: "Account State",
            accessor: "AccountState",
            filter: "AccountState",
            sortType: "basic",
        },
        {
            Header: "Account Zip",
            accessor: "AccountZip",
            filter: "AccountZip",
            sortType: "basic",
        },
        {
            Header: "Product NDC Type",
            accessor: "ProductNDCType",
            filter: "ProductNDCType",
            sortType: "basic",
        },
        {
            Header: "Product NDC",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        },
        {
            Header: "Product Description",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
        },
        {
            Header: "REF ID Type",
            accessor: "REFIDType",
            filter: "REFIDType",
            sortType: "basic",
        },
        {
            Header: "Invoice #",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "Qty",
            accessor: "Qty",
            filter: "Qty",
            sortType: "basic",
        },
        {
            Header: "UOM",
            accessor: "UOM",
            filter: "UOM",
            sortType: "basic",
        },
        {
            Header: "Shipped Date",
            accessor: "ShippedDate",
            filter: "ShippedDate",
            sortType: "basic",
              filterMethod: (filter, row) => {
                 const rowValue = row.original
                 return rowValue.datefiled.includes(filter.value)
             }
        },
        {
            Header: "Product Transfer Indicator",
            accessor: "ProductTransferIndicator",
            filter: "ProductTransferIndicator",
            sortType: "basic",
        },
        {
            Header: "Drop Shipped Indicator",
            accessor: "DropShippedIndicator",
            filter: "DropShippedIndicator",
            sortType: "basic",
        }
    ];
    async function headerData(salesFee) {
        var data_to_download = []
        salesFee.map((data, pidex) => {
            let record_to_download = {}
            columns.map((col, cindex) => {
                record_to_download[columns[cindex].Header.toUpperCase()] = salesFee[pidex][columns[cindex].accessor]
            })
            data_to_download.push(record_to_download)
        })
        exportToCSV(data_to_download)
    }
    const exportToCSV = (data_to_download) => {
        var wscols = [{ wch: 20, color: 'aabbcc' }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const ws = XLSX.utils.json_to_sheet(data_to_download);
        ws["!cols"] = wscols;
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "Sales Report Source Data (Monthly)");
    }
    useEffect(() => {
        getSalesSource();
    }, []);

    async function getSalesSource() {
        setLoading(true);
        await _HttpServices
        // api/inbound/GetSalesSourceData852?startDate=05/31/17&endDate=07/14/17
        
            .getData(`api/inbound/GetSalesSourceData852?fileprocessId=${outbounddata.File_Process_ID}`)
            .then((data) => {
            const ServiceSourceResult = data.data;
                if(ServiceSourceResult.length > 0){
                    ServiceSourceResult.map((res) => {
                      res.ShippedDate = moment(res.ShippedDate).format('MM/DD/YYYY');
                    })
                  }
                  setSalesSource(ServiceSourceResult)
                setLoading(false);
                
            })
            .catch((e) => console.log(e));
    }

    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">SalesSource</h2>
                {/* <span role="img" aria-label="emoji">💩</span> */}
                {/* <Button><IoIosAdd className="icon btn-icon" />Add</Button> */}
                {loading ? <Loader /> : null}

                <Button type="submit" onClick={() => headerData(salesSource)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>

            </div>
            <Row>
                <Col md={12}>
                    {/* <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <Form>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="StartDate">
                                                    Start Date<span className="required">*</span>
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => setStartDate(date)}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="EndDate">
                                                    End Date<span className="required">*</span>
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mt-1">
                                            <Button type="submit" className="mt-4" disabled><IoMdDoneAll className="icon btn-icon" />Submit</Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div> */}

                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                                <Fragment>
                                    {salesSource.length > 0 ? (
                                        <ReactTable columns={columns} data={salesSource} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            
            <Footer />
        </section>
    );

}
export default SalesSourcePage;